import React, { FunctionComponent, PropsWithChildren } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { EmptyObjectType } from "@multiweb/types/react";
import { FlexDirection, Layout, SpacingSize } from "../Layout";

const classNames = bemClassNames("select-body-component");

export type SelectBodyProps = PropsWithChildren<EmptyObjectType>;

/** Komponenta těla rozevíracího seznamu */
export const SelectBody: FunctionComponent<SelectBodyProps> = ({ children }) => (
    <div className={classNames()}>
        <Layout
            spacingSizeVertical={SpacingSize.xs}
            flexDirection={FlexDirection.column}
        >
            {children}
        </Layout>
    </div>
);
